/* Newsletter footer form → POST admin-ajax → wyświetl komunikat.
 * ponytail: fetch + FormData, brak deps.
 */
(function () {
	var form = document.querySelector('[data-kb-newsletter]');
	if (!form) return;

	var msg    = form.parentElement.querySelector('[data-kb-newsletter-msg]');
	var btn    = form.querySelector('button[type="submit"]');
	var input  = form.querySelector('input[name="email"]');
	var cfg    = window.KB_NEWSLETTER || {};
	var busy   = false;

	function say(text, ok) {
		if (!msg) return;
		msg.textContent = text;
		msg.style.color = ok ? '#a7f3d0' : '#fca5a5';
	}

	form.addEventListener('submit', function (e) {
		e.preventDefault();
		if (busy) return;

		var email = (input && input.value || '').trim();
		if (!email || email.indexOf('@') === -1) {
			say('Wpisz poprawny adres email.', false);
			return;
		}

		busy = true;
		btn.disabled = true;
		say('Zapisywanie…', true);

		var data = new FormData(form);
		data.append('action', 'kb_newsletter_subscribe');

		fetch(cfg.ajax || '/wp-admin/admin-ajax.php', {
			method: 'POST',
			body: data,
			credentials: 'same-origin',
		})
			.then(function (r) { return r.json().catch(function () { return null; }); })
			.then(function (json) {
				if (json && json.success) {
					say((json.data && json.data.msg) || 'Zapisano — sprawdź skrzynkę.', true);
					if (input) input.value = '';
				} else {
					say((json && json.data && json.data.msg) || 'Coś poszło nie tak — spróbuj ponownie.', false);
				}
			})
			.catch(function () {
				say('Brak połączenia — spróbuj ponownie za chwilę.', false);
			})
			.finally(function () {
				busy = false;
				btn.disabled = false;
			});
	});
})();
